export default __webpack_public_path__ + "static/media/react.dff0daa0.svg";